// export const BASE_URL = 'https://api.scherbinin.diploma.nomoredomains.club';
export const BASE_URL = 'http://localhost:3100';
// export const FNS_KEY = 'd4edd0c275bb4277da9e6bb97dcfae4d3624d5c6'; //yandex (work)
// export const FNS_KEY = 'c6e21902350949677ee00dee8c3ef40954810c67'; //wertig768@gmail.com (mobile work)
export const FNS_KEY = '074ffd8f146b8179e13bb3a68c07a9f159cc9611'; //vsevolod.o.sh@mail.ru (home)
// export const FNS_KEY = '3e21d9f1e9de873bd640da24bfb24a620a79a6fe'; //shcherbinin@centr-prioritet.ru (paid)
